export default class GetStarted {
    constructor(selector = '[href*="|FARMDOK_GET_STARTED"]') {
        if (typeof selector === 'string') {
            Array.from(document.querySelectorAll(selector)).forEach(el => {
                new GetStarted(el);
            });
            return;
        }

        this.el = selector;
        this.originalHref = this.el.getAttribute('href');

        this.el.addEventListener('click', (e) => {
            e.preventDefault();
            this.redirectAccordingToUserAgent();
        });
    }

    redirectAccordingToUserAgent() {
        if (navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i)) {
            window.location.href = 'https://apps.apple.com/at/app/farmdok/id1258098246';
            return;
        }
        if (navigator.userAgent.match(/Android/i)) {
            window.location.href = 'https://play.google.com/store/apps/details?id=com.farmdok.android';
            return;
        }
        if (this.originalHref !== '|FARMDOK_GET_STARTED') {
            window.open(this.originalHref.replace('#|FARMDOK_GET_STARTED', '').replace('|FARMDOK_GET_STARTED', ''));
            return;
        }
        window.open('https://app.farmdok.com/register/');
    }
}



// WEBPACK FOOTER //
// ./app/themes/template/res/js/src/GetStarted.js